import React, { useState } from "react";
import { useDispatch } from "react-redux";
import aiChampIcon from "../../assets/gifs/Ai Robot Vector Art.gif";
import { setIsOpen, setExternalQuery } from "../../redux/slices/aiAssistantSlice";
import "./ai-champion.css";

const AiChampion = ({ theme }) => {
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();

  const handleSearch = () => {
    if (query.trim()) {
      dispatch(setExternalQuery(query));
      dispatch(setIsOpen(true));
      setQuery("");
    }
  };

  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#161616" : "#ffffff",
      }}
      className="ai-champion-container">
      <div className="ai-camp-gif"><img src={aiChampIcon} alt="ai-champ-image" style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "50%" }} /></div>
      <div
        style={{
          flex: "1",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}>
        <h2 className="ai-champ-title">AI Companion:</h2>
        <div className="ai-champion-search-filter">
          <input
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "#F4F7FE",
              border: theme === "dark" ? "#232323" : "#F4F7FE",
            }}
            type="text"
            name="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            placeholder="Hi, I am your Asset Planet AI Assistant. Ask me anything..."
          />
          <button onClick={handleSearch}>Search</button>
        </div>
      </div>
    </div>
  );
};

export default AiChampion;
